/* eslint-disable no-unused-vars */
import { Form, Input } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import Button from 'components/Button';
import AuthServices from 'services/AuthServices';
import { ACCESS_TOKEN_KEY } from 'helper/init.constants';
import { ROUTE_PATH } from 'routes/route.constant';
import {
  isRegexFullWidthCharacter,
  isRegexSpecialCharacter,
  isRegexSpecialCharacterJP,
  isValidEmail,
  isValidPassword,
} from 'helper/utils';
import { NO_INTERNET } from 'components/messageError';

const LoginForm = ({ onToggle }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  // call api login
  const handleSubmit = () => {
    setLoading(true);
    setDisableSubmit(true);
    form
      .validateFields()
      .then((val) => {
        setLoading(true);
        const body = {
          email: val.email,
          password: val.password,
          environment: 'WEB_ADMIN',
        };
        AuthServices.logIn(body)
          .then((res) => {
            if (res.isOk) {
              toast.success('ログインに成功しました');
              localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(res.data));
              navigate(ROUTE_PATH.HOME);
            }
          })
          .catch((err) => {
            toast.error(err?.message || err || NO_INTERNET);
          })
          .finally(() => {
            setLoading(false);
            setDisableSubmit(false);
          });
      })
      .catch((err) => {
        return err;
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <h2 className="text-welcome">おかえりなさい</h2>
      <div className="relative flex flex-col">
        <Form form={form}>
          <Form.Item
            normalize={(value) => value.replace(/\s+/g, '')}
            rules={[
              {
                required: true,
                validateTrigger: 'onChange',
                message: 'メールアドレスを入力してください',
              },
              {
                pattern: isValidEmail(),
                validateTrigger: 'onChange',
                message: '有効なメールアドレスを入力してください',
              },
            ]}
            name={'email'}
          >
            <Input
              placeholder="メールアドレス"
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSubmit();
              }}
            />
          </Form.Item>
          <Form.Item
            normalize={(value) => value.replace(/\s+/g, '')}
            rules={[
              {
                required: true,
                validateTrigger: 'onChange',
                message: 'パスワードを入力してください',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  if (isRegexFullWidthCharacter().test(value)) {
                    return Promise.reject('半角文字で入力してください');
                  }

                  if (isRegexSpecialCharacterJP().test(value)) {
                    return Promise.reject(
                      'パスワードに特殊文字は使用できません'
                    );
                  }

                  if (!isRegexSpecialCharacter().test(value)) {
                    return Promise.reject(
                      'パスワードに特殊文字は使用できません'
                    );
                  }
                  if (!isValidPassword().test(value)) {
                    return Promise.reject(
                      'パスワードは6～14文字で入力してください'
                    );
                  }
                  return Promise.resolve();
                },
                validateTrigger: 'onChange',
              },
            ]}
            name={'password'}
          >
            <Input.Password
              placeholder="パスワード "
              className="input-password"
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSubmit();
              }}
            />
          </Form.Item>
        </Form>
        <h2
          className="btn-forgot"
          style={{
            color: '#00805A',
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '30px',
            cursor: 'pointer',
          }}
          onClick={onToggle}
        >
          パスワードを忘れた場合
        </h2>
        <Button
          btnType="primary"
          fontWeight="bold"
          loading={loading}
          className="btn-login !w-full"
          onClick={handleSubmit}
        >
          ログイン
        </Button>
      </div>
    </>
  );
};

export default LoginForm;
